module.exports = __webpack_public_path__ + "media/images/faq-title-6ba9e0363e2670a671b33bbccf4100e4.svg";